import {createResource, getFile, getResource} from "./common"
import {Authorization} from "./authorization"
import {v4 as uuidv4} from "uuid"

export enum AccountHoldsStatus {
	Active = "Active",
	Released = "Released",
	Expired = "Expired",
}

export type AccountHold = {
	id: string
	attributes: {
		createdAt: Date
		amount: Cents
		status: AccountHoldsStatus
		expiredAt?: Date
		releasedAt?: Date
	}
	relationships: {
		account: {
			data: {
				type: string
				id: string
			}
		}
	}
}

export type Cents = number

export async function createAccountHold(accessToken: string, accountId: string, amount: number, expiredAt: string) {
	const result = await createResource<AccountHold>("account-holds", accessToken, {
		type: "accountHold",
		attributes: {
			amount,
			expiredAt,
			idempotencyKey: uuidv4(),
		},
		relationships: {
			account: {
				data: {
					id: accountId,
					type: "account",
				},
			},
		},
	})

	return result.map((v) => v.data)
}

export async function getAccountHold<AccountHold>(accessToken: string, accountId: string, id: string) {
	const result = await getResource<AccountHold>(`account-holds/${id}`, accessToken, {
		filter: {
			accountId,
		},
	})

	return result.map((v) => v.data)
}

export async function releaseAccountHold(accessToken: string, accountId: string, id: string) {
	return await createResource<Authorization>(`account-holds/${id}/release`, accessToken, {
		filter: {
			accountId,
		},
	})
}

interface AccountHoldGetRequestParam {
	accessToken: string
	offset: number
	limit?: number
	searchQuery?: string
	since?: string
	until?: string
	accountId?: string | null
	requestType: "json" | "csv"
	sort: string
}

export async function getAccountHoldsRequest(requestParam: AccountHoldGetRequestParam) {
	const query = {
		page: {
			limit: requestParam.limit,
			offset: requestParam.offset,
		},
		filter: {
			query: requestParam.searchQuery != "" ? requestParam.searchQuery : null,
			since: requestParam.since != "" ? requestParam.since : null,
			until: requestParam.until != "" ? requestParam.until : null,
			accountId: requestParam.accountId != "" ? requestParam.accountId : null,
		},
		sort: requestParam.sort,
		dashboard: true,
	}

	switch (requestParam.requestType) {
		case "csv":
			return await getFile("account-holds", requestParam.accessToken, query)
		default:
			return await getResource<Array<AccountHold>>("account-holds", requestParam.accessToken, query)
	}
}
